export const api = {
    userInfo: (userId: string) => `/api/admin/room-wizard/users/${userId}/`,
    createInvitation: () => '/api/admin/room-wizard/members/',
    removeInvitation: (memberId: string) => `/api/admin/room-wizard/members/${memberId}/`,
    bulkInvite: () => '/api/admin/room-wizard/members/bulk-invite/',
    organisationsAutoComplete: () => '/admin/organisation-autocomplete/',
    usersAutoComplete: () => '/admin/user-autocomplete/',
    createRoomAdmin: () => '/api/admin/rooms/',
    getRoomAdmin: (roomId: string) => `/api/admin/rooms/${roomId}/`,
    updateRoomAdmin: (roomId: string) => `/api/admin/rooms/${roomId}/`,
    getSalesUsers: () => '/accounts/users/sales/'
};
